import { Breadcrumbs } from "../../../AbstractElements";
import { Tooltip, UiKits } from "../../../Constant";
import { Container, Row } from "reactstrap";
import BasicTooltip from "./BasicTooltip";
import ColoredTooltip from "./ColoredTooltip";
import TooltipDirections from "./TooltipDirections";
import ElementsWithHoverEffect from "./ElementsWithHoverEffect";
import FilledTooltip from "./FilledTooltip";

const TooltipContainer = () => {
  
  return (
    <>
      <Breadcrumbs title={Tooltip} pageTitle={Tooltip} parent={UiKits} />
      <Container fluid>
        <Row>
          <BasicTooltip />
          <ColoredTooltip />
          <TooltipDirections />
          <ElementsWithHoverEffect/>
          <FilledTooltip/>
        </Row>
      </Container>
    </>
  );
};

export default TooltipContainer;
